import { NgClass } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ButtonModule, copyToClipboard, IconModule, PopoverDirective } from '@hglobal/common';

@Component({
  imports: [IconModule, PopoverDirective, ButtonModule, NgClass],
  selector: 'pp-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  readonly text = input<string>();
  readonly iconName = input('info');
  readonly isCopy = input<boolean, unknown>(undefined, { transform: booleanAttribute });
  readonly customContent = input<boolean, unknown>(undefined, { transform: booleanAttribute });
  // TODO: Notes from signal input migration:
  //  Input type is incompatible with transform. The migration added an `any`
  //  cast. This worked previously because Angular was unable to check transforms.
  readonly position = input<string, unknown>(undefined, { transform: booleanAttribute as any });
  readonly size = input<'small' | 'medium'>('medium');
  readonly withoutIcon = input(false);

  copyToClipboard(text: string | number | boolean): void {
    copyToClipboard(text.toString());
  }
}
